<template>
  <v-dialog
    v-model="dialog"
    max-width="750"
    persistent
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs12>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="pb-0">
        <p class="f-1 mb-0">
          {{ $t('publish.question') }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1"
            shrink
            :class="[$vuetify.breakpoint.xs ? 'mt-3' : 'mr-4']"
          >
            <a @click="canceled()">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            shrink
          >
            <v-btn
              :loading="loading"
              color="sz_violet"
              @click="send()"
            >
              {{ $t('publish.button_ok') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'PublishingModal',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        familyId: {
            required: true
        }
    },
    data () {
        return {
            dialog: false,
            loading: false
        };
    },
    watch: {
        visible (val) {
            this.dialog = val;
        },
        dialog () {
            if (!this.dialog) {
                this.$emit('close', false);
            }
        }
    },
    methods: {
        closeDialog () {
            this.dialog = false;
            this.$emit('close', false);
        },
        canceled () {
            this.closeDialog();
        },
        publish () {
            return this.$store.dispatch('audit/publishSheets', this.familyId);
        },
        async send () {
            this.loading = true;
            await this.publish();
            this.redirectToFamilyCard();
            this.loading = false;
        },
        redirectToFamilyCard () {
            this.closeDialog();
            this.$emit('redirect');
            this.$router.push({ name: 'family-card', params: { id: this.familyId } });
        }
    }
};
</script>

<style scoped></style>
